import { Action } from '@/graphql/generated/schemas'

export const mockedRules = {
  data: {
    rules: {
      edges: [
        {
          node: {
            id: '1',
            createdAt: '2024-06-14T21:55:00Z',
            name: 'Ignore gym at the weekend',
            lastMatched: null,
            status: true,
            action: Action.Mute,
            isV2: false,
            creator: {
              id: 'u-1',
              firstName: 'Jordan',
              lastName: 'Reyes',
            },
          },
        },
        {
          node: {
            id: '2',
            createdAt: '2024-05-26T18:12:00Z',
            name: 'Ignore all for a week',
            lastMatched: '2024-05-28T13:33:00Z',
            status: true,
            action: Action.EnableAiOperator,
            aiOperatorRuleDetails: {
              isDryRun: true,
            },
            isV2: false,
            // Creator present but with null name parts → should still render N/A.
            creator: {
              id: 'u-2',
              firstName: null,
              lastName: null,
            },
          },
        },
        {
          node: {
            id: '3',
            createdAt: '2024-05-24T18:12:00Z',
            name: 'One more for the craic',
            lastMatched: '2024-06-30T08:33:00Z',
            status: false,
            action: Action.EnableAiOperator,
            aiOperatorRuleDetails: {
              isDryRun: false,
            },
            isV2: false,
          },
        },
        {
          node: {
            id: '4',
            createdAt: '2024-06-14T21:55:00Z',
            name: 'Ignore gym at the weekend',
            lastMatched: null,
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '5',
            createdAt: '2024-05-26T18:12:00Z',
            name: 'Ignore all for a week',
            lastMatched: '2024-05-28T13:33:00Z',
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '6',
            createdAt: '2024-05-24T18:12:00Z',
            name: 'One more for the craic',
            lastMatched: '2024-06-30T08:33:00Z',
            status: false,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '7',
            createdAt: '2024-06-14T21:55:00Z',
            name: 'Ignore gym at the weekend',
            lastMatched: null,
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '8',
            createdAt: '2024-05-26T18:12:00Z',
            name: 'Ignore all for a week',
            lastMatched: '2024-05-28T13:33:00Z',
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '9',
            createdAt: '2024-05-24T18:12:00Z',
            name: 'One more for the craic',
            lastMatched: '2024-06-30T08:33:00Z',
            status: false,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '10',
            createdAt: '2024-06-14T21:55:00Z',
            name: 'Ignore gym at the weekend',
            lastMatched: null,
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '11',
            createdAt: '2024-05-26T18:12:00Z',
            name: 'Ignore all for a week',
            lastMatched: '2024-05-28T13:33:00Z',
            status: true,
            action: Action.Mute,
            isV2: false,
          },
        },
        {
          node: {
            id: '12',
            createdAt: '2024-05-24T18:12:00Z',
            name: 'One more for the craic',
            lastMatched: '2024-06-30T08:33:00Z',
            status: false,
            action: Action.Mute,
            isV2: false,
          },
        },
      ],
      totalCount: 12,
    },
  },
}
